import { render, staticRenderFns } from "./scydzyjsxy.vue?vue&type=template&id=0cf9cfb0&scoped=true&"
import script from "./scydzyjsxy.vue?vue&type=script&lang=js&"
export * from "./scydzyjsxy.vue?vue&type=script&lang=js&"
import style0 from "./scydzyjsxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./scydzyjsxy.vue?vue&type=style&index=1&id=0cf9cfb0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf9cfb0",
  null
  
)

export default component.exports